/**
 * Slot Status Chip Component
 * Displays slot status with appropriate color
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import { SlotStatus, SLOT_STATUS_LABELS, SLOT_STATUS_COLORS } from '../../../types/scheduleSlot';

interface SlotStatusChipProps {
  status: SlotStatus;
  size?: 'small' | 'medium';
}

export const SlotStatusChip: React.FC<SlotStatusChipProps> = ({ status, size = 'small' }) => {
  return (
    <Chip
      label={SLOT_STATUS_LABELS[status] || status}
      color={SLOT_STATUS_COLORS[status] || 'default'}
      size={size}
      variant="outlined"
    />
  );
};

export default SlotStatusChip;
